export function getMapsUrl(coordinates: [number, number]) {
  const [lat, lng] = coordinates;
  return `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
}
